import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["No Excuses", "No Shortcuts", "Only Results"];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee-section" className="relative py-8 md:py-10 bg-[#E6DFD4] overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-word text-6xl md:text-8xl uppercase tracking-tight text-black px-8">
              {w}
            </span>
            <span className="marquee-word text-6xl md:text-8xl text-black/30 px-2">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
